import { z } from 'zod';

import { api } from 'common';
import { FlowDefinition } from 'vivaa-api';

import { CallbackFormFields } from './FormFields';
import { callbackDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

const { DurationUnits } = FlowDefinition;
type DurationUnits = FlowDefinition.DurationUnits;

export const callbackBlockConfig: BlockConfigProps = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'callback',
  defaultConfig: {
    message: '',
    waitTime: {
      value: 45,
      units: DurationUnits.Seconds,
    },
    timeout: {
      value: 5,
      units: DurationUnits.Minutes,
    },
  },
  configFields: {
    schema: z.object({
      message: z.string().min(1, 'Message is required'),
      waitTime: api.FlowDefinition.DurationSchemaWithMax('value', {
        value: 30,
        units: DurationUnits.Minutes,
      }),
      timeout: api.FlowDefinition.DurationSchemaWithMax('value', {
        value: 1,
        units: DurationUnits.Hours,
      }),
    }),
    FormFields: CallbackFormFields,
  },
  documentationMarkdown: callbackDocumentationMarkdown,
};
